import Api from '@/services/Api'

export default {
  get(groupOfDiscountsId) {
    return Api().get(`groups-of-discounts/${groupOfDiscountsId}/coupons`).then(function (response) {
      return (response)
    })
  },  
  getById(id) {
      return Api().get(`coupons/${id}`).then(function (response) {
        return (response)
      })
  },
  getByGroupOfDiscountIdUnusedCoupon(groupOfDiscountsId){
    return Api().get(`groups-of-discounts/${groupOfDiscountsId}/unused/coupons`).then(function (response) {
      return (response)
    })
  }
  ,
  partialUpdate(id, data) {
      return Api().patch(`coupons/${id}`, data).then(function (response) {
        return (response)
      })
  },
  getByCampaignId(campaignId){
    return Api().get(`campaigns/${campaignId}/coupons`).then(function (response) {
      return (response)
    })
  }
}